import { useGetQuestionSetsQuery } from "./questionSetsApiSlice"
import QuestionSet from "./QuestionSet"
import useAuth from "../../hooks/useAuth"
import PulseLoader from 'react-spinners/PulseLoader'
import { faAdd } from "@fortawesome/free-solid-svg-icons"
import { Link, useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
const QuestionSetsList = ({course,  q}) => {
    const {groupId, type} = useParams()
    const {  isTeacher, isAdmin } = useAuth()
    const {
        data: questionSets,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetQuestionSetsQuery('questionSetsList', {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })



    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content =<> <p className="errmsg">{error?.data?.message}
        
        </p>
        <Link to={`/${type}/${groupId}/question-sets/new`}>
        <FontAwesomeIcon icon={faAdd} />הוספת שאלון
               </Link></>
    }

    if (isSuccess ) {
        const { ids, entities } = questionSets
       
        let filteredIds = []
        if( course || q!==''){
            filteredIds=[...ids].filter(questionSetId =>{
                const questionSet =  entities[questionSetId]
             return (
                    (!course ||questionSet.course._id === course ) &&
                    (q==='' ||(questionSet.title.indexOf(q) >-1)))

            })
        }else
            {
                filteredIds = [...ids]
            }
        let addButtn= null
        if(isAdmin || isTeacher){
        addButtn = (
        <Link to={`/${type}/${groupId}/question-sets/new`}>
 <FontAwesomeIcon icon={faAdd} />הוספת שאלון
        </Link>
        
      )
        }

        const tableContent = ids?.length && filteredIds.map(questionSetId => <QuestionSet key={questionSetId} questionSetId={questionSetId} />)

        content = (
            <>
            {addButtn}
            <table className={`table table--questionSets ${(isAdmin || isTeacher)&& "table--questionSets--admin"} `}>
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th questionSet__title">שאלון</th>
                        <th scope="col" className="table__th questionSet__body">קורס</th>
                        <th scope="col" className="table__th questionSet__dates">נוצר על ידי</th>
                        <th scope="col" className="table__th questionSet__actions"> שאלות</th>
                        <th scope="col" className="table__th questionSet__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default QuestionSetsList